module.exports = require("./fr-MQ.d.ts");